// src/components/AnimatedButton.jsx
import React from "react";

export function AnimatedButton1({
  text = "Join the club",
  className = "",
  onClick,
}) {
  return (
    <button
      onClick={onClick}
      className={`
        group relative w-auto cursor-pointer overflow-hidden rounded-full
        border  px-6 py-2.5 text-sm font-semibold text-black
        transition-all hover:bg-black focus:ring-2 focus:border-y-black
        focus:ring-offset-2 focus:outline-none ${className}
      `}
    >
      {/* Hidden background element that scales on hover */}
      <div className="flex items-center gap-2">
        <div className="size-2 scale-100 rounded-lg bg-black transition-all duration-300 group-hover:scale-[100.8]" />
        <span className="inline-block whitespace-nowrap transition-all duration-300 group-hover:translate-x-12 group-hover:opacity-0">
          {text}
        </span>
      </div>

      {/* Hover-revealed text + arrow */}
      <div
        className="
          absolute top-0 z-10 flex h-full w-full translate-x-12
          items-center justify-center gap-2 text-white opacity-0
          transition-all duration-300 group-hover:-translate-x-5
          group-hover:opacity-100
        "
      >
        <span className="whitespace-nowrap">{text}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-arrow-right"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </div>
    </button>
  );
}
